import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const gbp = (n) => `£${(Number(n) || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function JobPaymentsSummary({ legacyId, fallbackTotal = 0, compact = false, testid = "job-payments" }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/tasks/${legacyId}/invoices`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [legacyId]);
  if (!d) return null;
  const s = d.summary || {};
  const live = (d.items || []).filter((i) => !i.superseded);
  const pays = live.flatMap((i) => (i.payments || []).map((p) => ({ ...p, invoice_no: i.invoice_no })))
    .sort((a, b) => String(a.date || "").localeCompare(String(b.date || "")));
  const held = s.held_deposits || 0;
  const paid = (s.paid || 0) + held;
  const base = live.length ? s.invoiced || 0 : fallbackTotal;
  const owed = Math.max(base - paid, 0);
  const px = compact ? "" : "px-5";
  return (
    <div className={`border-t border-slate-100 mt-1 pt-2 ${compact ? "mt-3" : ""}`} data-testid={testid}>
      <div className={`flex items-center justify-between py-2 text-sm ${px}`}>
        <span className="text-slate-600">Paid so far</span>
        <span className="font-semibold text-emerald-600" data-testid={`${testid}-paid`}>{gbp(paid)}</span>
      </div>
      {pays.map((p) => (
        <div key={p.id} className={`flex items-center justify-between py-0.5 text-[11px] text-slate-400 ${compact ? "pl-3" : "px-8"}`} data-testid={`${testid}-row-${p.id}`}>
          <span className="truncate">{p.date || "—"} · {p.method || "Payment"}{p.note ? ` · ${p.note}` : ""}{p.invoice_no ? ` · ${p.invoice_no}` : ""}</span>
          <span className="shrink-0 ml-3">{gbp(p.amount)}</span>
        </div>
      ))}
      {held > 0 && (
        <div className={`flex items-center justify-between py-0.5 text-[11px] text-blue-500 ${compact ? "pl-3" : "px-8"}`} data-testid={`${testid}-held`}>
          <span>Deposit held (not yet invoiced)</span><span>{gbp(held)}</span>
        </div>
      )}
      <div className={`flex items-center justify-between py-2 text-sm ${px}`}>
        <span className="text-slate-600">Still owed <span className="text-[11px] text-slate-400">{live.length ? "of invoiced" : "of accepted quote"}</span></span>
        <span className={`font-semibold ${owed > 0 ? "text-rose-600" : "text-slate-900"}`} data-testid={`${testid}-owed`}>{gbp(owed)}</span>
      </div>
    </div>
  );
}
